import { Link } from "../i18n";
import { motion } from "framer-motion";
import { ArrowUpRight, Gauge, Calendar, Cog } from "lucide-react";
import { useLang } from "../i18n";

const STATUS_STYLE = {
  available: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  reserved: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  sold: "bg-red-500/15 text-red-400 border-red-500/30",
};

export default function VehicleCard({ vehicle, index = 0 }) {
  const { t } = useLang();
  const v = vehicle;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/inventory/${v.id}`}
        data-testid={`vehicle-card-${v.id}`}
        className="group block bg-[#12141D] border border-white/10 rounded-2xl overflow-hidden hover:border-[rgba(68,153,247,0.4)] transition-colors duration-500"
      >
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={v.image?.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${v.image}` : v.image}
            alt={v.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B10]/90 via-transparent to-transparent" />
          <span
            data-testid={`vehicle-status-${v.id}`}
            className={`absolute top-4 left-4 text-[11px] font-mono-num tracking-widest uppercase border rounded-full px-3 py-1 backdrop-blur-md ${STATUS_STYLE[v.status] || STATUS_STYLE.available}`}
          >            {t(`status.${v.status}`)}
          </span>
          {v.offer && (
            <span
              data-testid={`vehicle-offer-ribbon-${v.id}`}
              className="absolute top-5 -right-9 rotate-45 bg-amber-400 text-[#0A0B10] text-[10px] font-mono-num font-bold tracking-[0.2em] uppercase px-10 py-1 shadow-lg"
            >
              {t("offer.badge")}
            </span>
          )}
          <span className="absolute bottom-4 left-4 font-mono-num text-xl font-bold text-[#4499F7]" data-testid={`vehicle-price-${v.id}`}>
            €{v.price.toLocaleString("en-US").replace(/,/g, " ")}
          </span>
        </div>
        <div className="p-6">
          <div className="flex items-start justify-between gap-3">
            <h3 className="font-display font-semibold text-lg leading-snug text-slate-100 group-hover:text-[#4499F7] transition-colors">
              {v.title}
            </h3>
            <ArrowUpRight size={20} className="text-slate-500 group-hover:text-[#4499F7] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0 mt-1" />
          </div>
          <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-slate-400 font-mono-num tracking-wide">
            {v.year && (
              <span className="flex items-center gap-1.5"><Calendar size={13} className="text-slate-500" />{v.year}</span>
            )}
            {v.mileage > 0 && (
              <span className="flex items-center gap-1.5"><Gauge size={13} className="text-slate-500" />{v.mileage.toLocaleString("en-US").replace(/,/g, " ")} {t("det.km")}</span>
            )}
            {v.gearbox && (
              <span className="flex items-center gap-1.5"><Cog size={13} className="text-slate-500" />{v.gearbox.split(" ")[0]}</span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
